import type { MutableRefObject } from 'react';
import { useEffect, useRef } from 'react';

export const useAsRef = <T>(value: T): MutableRefObject<T> => {
  const ref = useRef(value);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref;
};

export default useAsRef;
